export default {
      id: "sli-copy-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.43681d49.svg#sli-copy",
      toString: function () {
        return this.url;
      }
    }